import type { Option } from '@comparit/core';
import { Bauweise } from '../../../interfaces';

/** Wording taken from the B2B calculator, so both ask the question the same way. */
export const bauweiseOptions: Option<Bauweise>[] = [
  { label: 'Massiv', value: Bauweise.Massiv },
  {
    label: 'Stahl-/Holzfachwerk (feuerhemmende Verkleidung)',
    value: Bauweise.StahlHolzfachwerkFv,
  },
  {
    label: 'Stahl-/Holzfachwerk (beliebige Verkleidung)',
    value: Bauweise.StahlHolzfachwerkBv,
  },
  { label: 'Holz', value: Bauweise.Holz },
];
